import { LayoutFloor } from "./LayoutFloor";
import { LayoutUnitProps } from "./LayoutUnit";

export interface LayoutProps {
  floors: LayoutFloor[];
}

export interface UnitPositionProps {
  floorIndex: number;
  unitIndex: number;
}
export class UnitPosition {
  constructor(readonly floorIndex: number, readonly unitIndex: number) {}

  static create(props: UnitPositionProps) {
    return new UnitPosition(props.floorIndex, props.unitIndex);
  }

  sameTo(otherProps: UnitPositionProps) {
    return (
      this.floorIndex === otherProps.floorIndex &&
      this.unitIndex === otherProps.unitIndex
    );
  }
}

export class Layout {
  constructor(readonly floors: LayoutFloor[]) {}

  static create(props: LayoutProps) {
    return new Layout(props.floors.map((x) => LayoutFloor.create(x)));
  }

  popFloor(): LayoutFloor {
    if (!this.floors.length) return;

    return this.floors.pop();
  }

  pushFloor() {
    this.floors.push(LayoutFloor.empty());
  }

  get isValid() {
    return this.floors.every((x) => x.filled);
  }

  public sameTo(otherProps: LayoutProps) {
    if (this.floors.length !== otherProps.floors.length) return false;

    for (let i = 0; i < this.floors.length; i++)
      if (!this.floors[i].sameTo(otherProps.floors[i])) return false;

    return true;
  }

  getUnit(position: UnitPositionProps) {
    return (
      position && this.floors[position.floorIndex]?.units[position.unitIndex]
    );
  }

  updateUnit(position: UnitPositionProps, unit: LayoutUnitProps) {
    return this.floors[position.floorIndex].updateUnit(
      position.unitIndex,
      unit
    );
  }

  pushUnit(floorIndex: number) {
    this.floors[floorIndex].pushUnit();
  }

  popUnit(floorIndex: number) {
    return this.floors[floorIndex].popUnit();
  }
}
